module.exports = __webpack_public_path__ + "4fc6ee1cc8f122c4da6c0dc69e615cf1.svg";